module.exports = __webpack_public_path__ + "img/bg-06.03ee1edc.jpg";